import {connect} from 'react-redux';
import TranslationScreen from '../../components/screens/TranslationScreen';
import {
    getTranslations,
    filterTranslationsBySearchString,
    openDialogAddTranslation
} from "../../actions/translationAction";

const mapStateToProps = state => {
    return {
        translations: state.translation.translations,
        addEditDialog: state.translation.addEditDialog,
        searchString: state.translation.searchString
    }
};

const mapDispatchToProps = dispatch => {
    return {
        getTranslations: (setAllVisible) => {
            dispatch(getTranslations(setAllVisible))
        },
        filterTranslationsBySearchString: (searchString) => {
            dispatch(filterTranslationsBySearchString(searchString))
        },
        openDialogAddTranslation: () => {
            dispatch(openDialogAddTranslation())
        }
    }
};

const TranslationScreenContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(TranslationScreen);

export default TranslationScreenContainer;